<div class="text-center" *ngIf="data">
  <div class="title d-none d-md-block font-weight-light">{{ data.title }}</div>
  <div class="app-bar d-flex justify-content-center">
    <app-get-apps analyticsCategory="Footer"></app-get-apps>
  </div>
</div>
